<template>
  <v-navigation-drawer app expand-on-hover color="white" class="noprint">
    <v-list dense nav>
      <v-list-group v-for="(item, i) in items" :key="i" :append-icon="appendIcon(item.children.length)" @click="loadContent2(item.path)" color="primary">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-card tile flat color="#efefef">
          <v-list-item v-for="subItem in item.children" :key="subItem.title" :to="subItem.path">
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="subItem.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'Menu',
  computed: {
    ...mapState(['user', 'menu', 'permissions']),
    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined
    },
    state() {
      return this.$store.state.menuVisible
    },
    items() {
      return this.$store.state.menu
    },
  },
  data: () => ({
    menuVisible: false,
    search: null,
    active: [],
    open: [],
    users: [],
    userRule: [],
    userMenuRule: [],
  }),
  methods: {
    loadContent() {
      if (this.active[0]) {
        this.$router.push({path: this.active[0].path})
      }
    },
    loadContent2(rota) {
      if (rota && rota !== this.$route.path) {
        this.$router.push({path: rota})
      }
    },
    closeFolders() {
      this.open = []
      this.active = []
    },
    getUserMenu() {
      this.itens = this.menu
    },
    appendIcon(children) {
      if (children > 0) {
        return 'mdi-chevron-down'
      } else {
        return ''
      }
    },
  },
  mounted() {
    this.getUserMenu()
  },
}
</script>

<style></style>
